<script lang="ts">
  import { stockTakeValues } from "../helpers/store";
  import type { StockTakeEntry } from "../helpers/types";

  export let row: StockTakeEntry;

  function onChange(e: Event & { currentTarget: HTMLInputElement }) {
    stockTakeValues.set({
      ...$stockTakeValues,
      [row.item_id]: Number(e.currentTarget.value),
    });
  }
  function onKeyDown(e: KeyboardEvent) {
    if (e.key === "-") {
      e.preventDefault();
    }
  }
</script>

<input
  type="number"
  min="0"
  bind:value={row.stock_take}
  on:input={onChange}
  on:keydown={onKeyDown}
  on:focus={(event) => event.currentTarget.select()}
  step="0.01"
/>

<style>
  input {
    width: 200px;
  }
</style>
